<template>
	
	<div>
		<Header :utilityNav="header.utilityNav" :siteNavigation="header.siteNavigation"></Header>
		
		<section class="springboard-page">
			<img src="https://picsum.photos/200/200?random" alt="Alternate Text" />
			<h1>We are directing you to our partner site.</h1>
			<p class="detail">
				We are taking you from <span>[category name]</span> to <span class="destination">[other site name]</span>
			</p>
			<div class="links">
				<a class="redirect-forward" href="#">Let's Go!</a>
                <a class="redirect-back" href="#">
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 257.6 451.8" xml:space="preserve">
                        <path d="M14.2,204.5L200.5,18.2c11.9-11.9,31.1-11.9,42.9,0c11.8,11.8,11.8,31.1,0,42.9L78.6,226l164.8,164.8 c11.9,11.9,11.9,31.1,0,42.9c-11.8,11.9-31,11.9-42.9,0L14.2,247.4c-5.9-5.9-8.9-13.7-8.9-21.4C5.3,218.2,8.3,210.4,14.2,204.5z" />
                    </svg>
                    Go Back
                </a>
			</div>
		</section>
		
		<Footer :contact="footer.contact" :nav="footer.nav" :social="footer.social" :legal="footer.legal"></Footer>
	</div>
	
</template>

<script>
	
	import Header from '../components/Header/Header.vue';
	import Footer from '../components/Footer/Footer.vue';
	import axios from 'axios';
	
	export default {
		name: 'SpringboardPage',
		
		components: {
			Header,
			Footer
		},
		
		data() {
			return {
				header: {
					utilityNav: {},
					siteNavigation: {}
				},
				footer: {
					contact: {},
					nav: [],
					social: [],
					legal: ""
				}
			}
		},
		
		mounted: function() {
			
			/* eslint-disable no-console */
			let self = this;
			
			let header = 'SampleData/HeaderData.json';
			axios.get(header).then(function(response) {
				
				self.header.utilityNav = response.data.utilityNav;
				self.header.siteNavigation = response.data.siteNavigation;
			})
			.catch(function (error) {
				console.log(error);
			});
			
			let footer = 'SampleData/FooterData.json';
			axios.get(footer).then(function(response) {
				
				self.footer.contact = response.data.contact;
				self.footer.nav = response.data.nav;
				self.footer.social = response.data.social;
				self.footer.legal = response.data.legal;
			})
			.catch(function (error) {
				console.log(error);
			});
		}
	}
	
</script>